import { isEmpty } from "./isEmpty"

type ConvertToLocaleParams = {
  amount: number | null | undefined
  currency_code: string | null | undefined
  minimumFractionDigits?: number
  maximumFractionDigits?: number
  locale?: string
  fallback?: string
}

export const convertToLocale = ({
  amount,
  currency_code,
  minimumFractionDigits,
  maximumFractionDigits,
  locale = "en-US",
  fallback = "—",
}: ConvertToLocaleParams) => {
  if (amount == null || Number.isNaN(amount)) {
    return fallback
  }
  return currency_code && !isEmpty(currency_code)
    ? new Intl.NumberFormat(locale, {
        style: "currency",
        currency: currency_code,
        minimumFractionDigits,
        maximumFractionDigits,
      }).format(amount)
    : amount.toString()
}
